import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { CustomerAccountComponent } from './customer-account.component';
import { CustomerAccountOperationComponent } from './customer-account-operation.component';
import { CustomerAccountReportComponent } from './customer-account-report.component';
import { CustomerAccountReturnComponent } from './customer-account-return.component';

@NgModule({
  declarations: [
    CustomerAccountComponent,
    CustomerAccountOperationComponent,
    CustomerAccountReportComponent,
    CustomerAccountReturnComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatSelectModule,
    MatTooltipModule,
    MomentDateModule
  ],
  exports: [
    CustomerAccountComponent,
    CustomerAccountOperationComponent,
    CustomerAccountReportComponent,
    CustomerAccountReturnComponent
  ]
})
export class CustomerAccountModule {}
